module.exports = __webpack_public_path__ + "img/dente_17.f6ecb7c4.svg";